$(document).ready(function() {

    /* Bei Klick auf das Karte-Icon soll die Sortierung ausgeblendet werden */
    $('.ttgIconShowOnMap').click(function() {
        $(".ttgSortierungen").hide();
    });

    /* Ausnahme: Die Merkzettel- und Karte-Icon bei der Liste soll nicht auf die Detailseite verlinken -> das ganze List-Item soll klickbar sein  */
    $(document).on("click", ".ttgListShare", function() {
        var thisObj = $(this);
        thisObj.addClass("ttgListShareClicked");
        setTimeout(function() {
            thisObj.removeClass("ttgListShareClicked");
        }, 1000);
        return false;
    });

    /* MOBILE: Ausspielung des Merkzettel- und Karte-Icons neben Titel */
    if ($('.ttgListShare').length) {
        if ($(window).width() >= 480 && $(window).width() <= 768) {
            $('.ttgListShare').each(function() {
                $(this).appendTo($(this).closest('.ttgListItemWrapper').children().find('.ttgMobileMerkenKarteWrapper'));
            });
        }
    }

});

$(window).resize(function() {
    if ($('.ttgListShare').length) {

        /* MOBILE: Ausspielung des Merkzettel- und Karte-Icons neben Titel */
        if ($(window).width() >= 480 && $(window).width() <= 768) {
            $('.ttgListShare').each(function() {
                $(this).appendTo($(this).closest('.ttgListItemWrapper').children().find('.ttgMobileMerkenKarteWrapper'));
            });
        }

        if ($(window).width() < 480 || $(window).width() > 768) {
            $('.ttgListShare').each(function() {
                $(this).appendTo($(this).closest('.ttgListItemWrapper').children().find('.ttgIconsAndShareWrapper'));
            });
        }
    }
});
